import { useState, type FormEvent } from 'react';
import { Alert, Button, Field, Input } from '../components/ui.js';
import { messageOf, useLogin } from '../lib/auth.js';

export function LoginPage() {
  const login = useLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  function onSubmit(event: FormEvent) {
    event.preventDefault();
    login.mutate({ email, password });
  }

  return (
    <main className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center p-6">
      <h1 className="text-xl font-semibold text-neutral-900">Konfigurator Cloudflare</h1>
      <p className="mt-1 mb-6 text-sm text-neutral-500">Panel pracownika</p>

      <form onSubmit={onSubmit} className="space-y-4">
        <Field label="Adres e-mail">
          <Input
            type="email"
            name="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Field>

        <Field label="Hasło">
          <Input
            type="password"
            name="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Field>

        {login.isError && <Alert tone="error">{messageOf(login.error)}</Alert>}

        <Button type="submit" disabled={login.isPending} className="w-full">
          {login.isPending ? 'Logowanie…' : 'Zaloguj się'}
        </Button>
      </form>

      <p className="mt-6 text-xs text-neutral-400">
        Konta zakłada administrator. Jeśli nie możesz się zalogować, skontaktuj się z nim.
      </p>
    </main>
  );
}
